import React, { useState } from 'react';
import Female06 from '../../assets/images/Female06.png'
import Female07 from '../../assets/images/Female07.png'
import { Avatar } from 'antd';
import MessagesAndInput from './MessagesAndInput';
import { PinIcon, SearchIcon, StarIcon } from '../../utils/icons';
import ChatAddPeopleModal from '../ChatAddPeopleModal';
import { useSelector } from 'react-redux';
import { getTime } from '../../utils/utils';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { LockOutlined } from '@ant-design/icons';
import AttachmentDisplay from './AttachmentDisplay';

const ChannelHeader = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const selectedChannel = useSelector(state => state.user.selectedUserOrChannel);
    const usersInChannel = useSelector((state) => state.user.usersInChannel) || {};

    console.log(usersInChannel[selectedChannel?.SK], "usersInChannel:channelHeader");

    return (
      <div className="flex justify-between items-center rounded-full w-full bg-gray-100 p-3">
        <div className="flex items-center gap-x-2">
          <div className="text-gray-600 text-2xl ml-1">
            {selectedChannel?.channelDetails?.SK === "Private#" ? 
              <CustomTooltip title="Private">
                <LockOutlined />
              </CustomTooltip>:
              <CustomTooltip title="Public">#</CustomTooltip>
            }
          </div>
          <div className="flex flex-col">
            <p className="text-black font-semibold font-bizmo 3xl:text-lg">
              {selectedChannel?.channelDetails?.ChannelName}
            </p>
            <p className="text-black text-sm no-break">
              {Object.keys(usersInChannel[selectedChannel?.SK] || {})?.length || 1} Participants
            </p>
          </div>
        </div>
        <CustomTooltip title="Click here to add peopl in Channel">
            <div
            className="hidden lg:block cursor-pointer"
            onClick={() => setIsModalOpen(true)}
            >
            <Avatar.Group>
              {Object.keys(usersInChannel[selectedChannel?.SK] || {})?.slice(0, 5)?.map(userId => 
                <Avatar size={"small"}>
                  {console.log(usersInChannel[selectedChannel?.SK][userId].Name, "usersInChannel[userId]?.Name", userId)}
                  {usersInChannel[selectedChannel?.SK][userId]?.Name?.slice(0, 1)}
                </Avatar>)}
            </Avatar.Group>
            </div>
        </CustomTooltip>
        <div className="flex items-center gap-2">
          <div className="flex items-center bg-pureWhite p-2 rounded-full">
            <input placeholder="Search" className="outline-none " />
            <SearchIcon />
          </div>
          <PinIcon />
          <StarIcon />
        </div>
        <ChatAddPeopleModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          title={selectedChannel?.channelDetails?.ChannelName}
        //   channelId={selectedChannel?.SK}
        />
      </div>
    );
};

const ChannelMessageListJSX = ({  messages=[], }) => {
    const userAttributes = useSelector((state) => state.user.userAttributes) || {};
    const usersInChannel = useSelector((state) => state.user.usersInChannel) || {};
    const selectedChannel = useSelector((state) => state.user.selectedUserOrChannel) || {};
    const msgLoading = useSelector(state => state.user.msgLoading);

    return(
      <div className="flex flex-col gap-y-1 flex-grow overflow-y-auto ">
        {messages?.length > 0 ? (
          messages?.map((msg, index) => {
            if (msg?.Sender?.includes(userAttributes?.sub)) {
              return (
                <div key={index} className="self-end w-full flex flex-col justify-end">
                  <p className="text-right pr-2 text-sm font-bold">You</p>
                  <div className="bg-gray-500 text-white rounded-t-md rounded-l-md mr-2 px-3 py-1 min-w-[130px] w-fit self-end max-w-[80%]">
                      {msg?.Attachments?.length > 0 && <AttachmentDisplay files={msg?.Attachments} />}
                      <p className={`text-white break-words ${msg?.Attachments?.length > 0 ? "mt-2": ""}`}>{msg?.Content}</p>
                      <p className={`text-right text-[10px] text-gray-100`}>
                        {getTime(msg?.CreatedAt)}
                      </p>
                  </div>
                </div>
              );
            }
            return (
              <div key={index} className="self-start w-full flex flex-col">
                  <p className="text-left text-sm font-bold">
                      {usersInChannel[selectedChannel?.SK][msg?.Sender]?.Name}
                  </p>
                  <div className="bg-gray-200 text-black rounded-t-md rounded-r-md ml-2 px-3 py-1 min-w-[130px]  w-fit max-w-[80%]">
                    {msg?.Attachments?.length > 0 && <AttachmentDisplay files={msg?.Attachments} />}
                    <p className={`text-black break-words ${msg?.Attachments?.length > 0 ? "mt-2": ""}`}>{msg?.Content}</p>
                    <p className="text-right text-[10px] text-gray-700">
                      {getTime(msg?.CreatedAt)}
                    </p>
                  </div>
              </div>
            );
          })
        ) : (
          <div className="flex justify-center items-center w-full h-full">
            <p className="text-gray-500 text-base">No Message</p>
          </div>
        )}
      </div>
    );
}

const ChannelMessagesAndInput = () => {
    const messagesObj = useSelector((state) => state.user.messagesObj) || {};
    const selectedChannel = useSelector(state => state.user.selectedUserOrChannel);
    const msgLoading = useSelector(state => state.user.msgLoading);
  return (
    <div className="flex flex-col w-full h-full relative">
        <ChannelHeader />
        {msgLoading ? 
            <div className="flex w-full h-full justify-center items-center">Loading...</div>
            :
            <>
              <ChannelMessageListJSX messages={messagesObj[selectedChannel?.SK]} />
              <MessagesAndInput type="channel"></MessagesAndInput>
            </>
        }
    </div>
  )
}

export default ChannelMessagesAndInput
